import { ArrowRightAlt } from '@material-ui/icons';
import { IconButton, ListItemText, MenuItem } from '@mui/material';
import * as React from 'react';
import { dateFormat } from 'v2/formatters/date';

import { useStyles } from './styles';

type EnvironmentProps = {
  name: string;
  env: string;
  branch: string;
  date: string;
  redirect: string;
};

function Details({ name, env, branch, date, redirect }: EnvironmentProps) {
  const classes = useStyles();
  return (
    <MenuItem>
      <ListItemText
        primary={<p className={classes.title}>{name}</p>}
        secondary={
          <div className={classes.details}>
            <p>
              <b>Env:</b> {env}
            </p>
            <p>
              <b>Branch:</b> {branch}
            </p>
            <p>
              <b>Data de Atualização:</b> {dateFormat(date, 'dd/MM/yyyy HH:mm:ss')}
            </p>
          </div>
        }
      />
      <a href={redirect} target='_blank' rel='noreferrer'>
        <IconButton>
          <ArrowRightAlt />
        </IconButton>
      </a>
    </MenuItem>
  );
}

export { Details };
